<template>
  <div>
    <img v-if="hasAvatar"
         v-show="avatarLoaded"
         :src="avatarSrc"
         alt="profile-avatar"
         class="avatar"
         @load="showAvatar"
    >
    <div v-show="!avatarLoaded" :style="avatarStyle" class="avatar">
      {{ avatarNickname }}
    </div>
    <img v-if="hasFlair"
         v-show="flairLoaded"
         :src="flairSrc"
         alt="avatar-flair"
         class="avatar-flair"
         @load="showFlair"
    >
  </div>
</template>

<script>

export default {
  name: "ProfileAvatar",
  props: {
    height: {
      type: Number,
      required: true,
    },
    avatarId: {
      type: Number,
      required: false,
      default: null,
    },
    gender: {
      type: Number,
      required: false,
      default: 0
    },
    nickname: {
      type: String,
      required: false,
      default: '',
    },
    flairSize: {
      type: Number,
      required: false,
      default: 12,
    },
    flairId: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  data() {
    return {
      avatarLoaded: false,
      flairLoaded: false
    }
  },

  computed: {
    hasAvatar() {
      return this.avatarId > 0
    },

    hasFlair() {
      return this.flairId > 0
    },

    avatarSrc() {
      return `${process.env.VUE_APP_BASE_BLOB}/${this.avatarId}`;
    },

    avatarStyle() {
      return {
        height: this.height + 'px',
        width: this.height + 'px',
        background: this.gender === 1 ? "#d9ecff" : "#ffe3f1",
        color: this.gender === 1 ? "#859fe5" : "#f285bc"
      }
    },

    avatarNickname() {
      let nickname = this.nickname

      if (!nickname) {
        return '';
      }

      if (nickname.match(/[a-zA-Z]/g)) {
        nickname = nickname.match(/[a-zA-Z]/g).join('');
      }

      nickname = nickname.slice(0,2);
      nickname = nickname.charAt(0).toUpperCase() + nickname.charAt(1).toLowerCase();

      return nickname || '';
    },

    flairSrc() {
      return `${process.env.VUE_APP_BASE_BLOB}/dpi128/${this.flairId}`;
    }
  },

  created() {
  },

  methods: {
    showAvatar() {
      this.avatarLoaded = true
    },
    showFlair() {
      this.flairLoaded = true
    }
  }
}
</script>

<style scoped lang="scss">
.profile-avatar {
  .avatar {
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2.4px solid #F7F7F7;
    box-shadow: 0 5px 7px #E5E5E5;
    font-weight: 300;
    font-size: 50px;
    line-height: 60px;
  }
  .avatar-flair {
    height: 48px;
    width: 48px;
    bottom: 0;
    left: 15px;
    position: absolute;
  }
}
</style>
